import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { Icons } from "src/util/enums/fontAwesomeIcons"
import { computed } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxSettingsField',
  props: {
  label: {
    type: String,
    required: true,
  },

  active: {
    type: Boolean,
    default: false,
  },

  disable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const activeClass = computed(() => {
  return { "sfx-settings-field-active": props.active }
})

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
    class: _normalizeClass(["text-body1 q-px-none sfx-settings-field", activeClass.value]),
    clickable: "",
    disable: props.disable,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.label), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, { avatar: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: _unref(Icons).LINK_ICON_FORWARD
          }, null, 8, ["name"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class", "disable"])), [
    [_directive_ripple]
  ])
}
}

})